const actions = {
  // BANNERS ACTIONS
  CREATE_BANNER_BEGIN: 'CREATE_BANNER_BEGIN',
  CREATE_BANNER_SUCCESS: 'CREATE_BANNER_SUCCESS',
  CREATE_BANNER_ERR: 'CREATE_BANNER_ERR',

  LIST_BANNERS_BEGIN: 'LIST_BANNERS_BEGIN',
  LIST_BANNERS_SUCCESS: 'LIST_BANNERS_SUCCESS',
  LIST_BANNERS_ERR: 'LIST_BANNERS_ERR',

  GET_BANNER_DETAILS_BEGIN: 'GET_BANNER_DETAILS_BEGIN',
  GET_BANNER_DETAILS_SUCCESS: 'GET_BANNER_DETAILS_SUCCESS',
  GET_BANNER_DETAILS_ERR: 'GET_BANNER_DETAILS_ERR',

  DELETE_BANNER_BEGIN: 'DELETE_BANNER_BEGIN',
  DELETE_BANNER_SUCCESS: 'DELETE_BANNER_SUCCESS',
  DELETE_BANNER_ERR: 'DELETE_BANNER_ERR',

  UPDATE_BANNER_BEGIN: 'UPDATE_BANNER_BEGIN',
  UPDATE_BANNER_SUCCESS: 'UPDATE_BANNER_SUCCESS',
  UPDATE_BANNER_ERR: 'UPDATE_BANNER_ERR',

  ENABLE_BANNER_BEGIN: 'ENABLE_BANNER_BEGIN',
  ENABLE_BANNER_SUCCESS: 'ENABLE_BANNER_SUCCESS',
  ENABLE_BANNER_ERR: 'ENABLE_BANNER_ERR',

  DISABLE_BANNER_BEGIN: 'DISABLE_BANNER_BEGIN',
  DISABLE_BANNER_SUCCESS: 'DISABLE_BANNER_SUCCESS',
  DISABLE_BANNER_ERR: 'DISABLE_BANNER_ERR',

  createBannerBegin: () => {
    return {
      type: actions.CREATE_BANNER_BEGIN,
    };
  },

  createBannerSuccess: (data) => {
    return {
      type: actions.CREATE_BANNER_SUCCESS,
      data,
    };
  },

  createBannerErr: (err) => {
    return {
      type: actions.CREATE_BANNER_ERR,
      err,
    };
  },

  listBannersBegin: () => {
    return {
      type: actions.LIST_BANNERS_BEGIN,
    };
  },

  listBannersSuccess: (data) => {
    return {
      type: actions.LIST_BANNERS_SUCCESS,
      data,
    };
  },

  listBannersErr: (err) => {
    return {
      type: actions.LIST_BANNERS_ERR,
      err,
    };
  },

  getBannerDetailsBegin: () => {
    return {
      type: actions.GET_BANNER_DETAILS_BEGIN,
    };
  },

  getBannerDetailsSuccess: (data) => {
    return {
      type: actions.GET_BANNER_DETAILS_SUCCESS,
      data,
    };
  },

  getBannerDetailsErr: (err) => {
    return {
      type: actions.GET_BANNER_DETAILS_ERR,
      err,
    };
  },

  updateBannerBegin: () => {
    return {
      type: actions.UPDATE_BANNER_BEGIN,
    };
  },

  updateBannerSuccess: (data) => {
    return {
      type: actions.UPDATE_BANNER_SUCCESS,
      data,
    };
  },

  updateBannerErr: (err) => {
    return {
      type: actions.UPDATE_BANNER_ERR,
      err,
    };
  },

  deleteBannerBegin: () => {
    return {
      type: actions.DELETE_BANNER_BEGIN,
    };
  },

  deleteBannerSuccess: (data) => {
    return {
      type: actions.DELETE_BANNER_SUCCESS,
      data,
    };
  },

  deleteBannerErr: (err) => {
    return {
      type: actions.DELETE_BANNER_ERR,
      err,
    };
  },

  enableBannerBegin: () => {
    return {
      type: actions.ENABLE_BANNER_BEGIN,
    };
  },

  enableBannerSuccess: (data) => {
    return {
      type: actions.ENABLE_BANNER_SUCCESS,
      data,
    };
  },

  enableBannerErr: (err) => {
    return {
      type: actions.ENABLE_BANNER_ERR,
      err,
    };
  },

  disableBannerBegin: () => {
    return {
      type: actions.DISABLE_BANNER_BEGIN,
    };
  },

  disableBannerSuccess: (data) => {
    return {
      type: actions.DISABLE_BANNER_SUCCESS,
      data,
    };
  },

  disableBannerErr: (err) => {
    return {
      type: actions.DISABLE_BANNER_ERR,
      err,
    };
  },
};

export default actions;
